faqQuestionList = {
    q1: "Why should I choose a Menstrual Cup instead of pads?",
    q2: "Why should I choose a Menstrual Cup instead of tampons?",
    q3: "How old do you need to be to try a Menstrual Cup?",
    q4: "Will a Menstrual Cup fit inside my vagina?",
    q5: "Isn’t it really hard to get the hang of using a Menstrual Cup?",
    q6: "Is a Menstrual Cup painful?",
    q7: "Is a Menstrual Cup painful to wear when I’m out and about?",
    q8: "Will I be able to feel the Menstrual Cup inside me at all?",
    q9: "Can you feel a Menstrual Cup when it’s inside?",
    q10: "Will a Menstrual Cup feel the same as a tampon when it’s inside me?",
    q11: "Does inserting a Menstrual Cup hurt?",
    q12: "Does removing a Menstrual Cup hurt?",
    q13: "Can a Menstrual Cup spill over inside me and leak everywhere?",
    q14: "Is it possible for the blood in my Menstrual Cup to backflow?",
    q15: "Will a menstrual cup hurt me like a tampon does?",
    q16: "I’m scared a Menstrual Cup might get lost inside me!",
    q17: "Can a Menstrual Cup get stuck?",
    q18: "How do you remove your menstrual cup without making a mess?",
    q19: "Can I sleep with a Menstrual Cup in like I can with tampons?",
    q20: "Can you sleep with a menstrual cup in, like you do with a tampon?",
    q21: "Can I use a pantyliner or pad with my Menstrual Cup for extra protection?",
    q22: "How many ml of fluid will fit into my BeYou Menstrual Cup?",
    q23: "How often should I be emptying my Menstrual Cup?",
    q24: "Does a Menstrual Cup smell or have an odour like sanitary pads and tampons can?",
    q25: "What else should I know before I switch to using a Menstrual Cup?",
    q26: "What if my parents don’t support my decision to use a Menstrual Cup?",
    q27: "How can I convince my daughter to try a Menstrual Cup?",
    q28: "What’s the truth? Should everyone use a Menstrual Cup?",
    q29: "Can I go to the toilet with a Menstrual Cup in?",
    q30: "How do I remove and empty my Menstrual Cup when I’m not at home?",
    q31: "Can I do sports with a Menstrual Cup in?",
    q32: "Will a Menstrual Cup help if I have period anxiety?",
    q33: "Will anyone be able to tell I’m using a Menstrual Cup?",
    q34: "Why aren’t Menstrual Cups as popular as pads or tampons?",
    q35: "Can I use a menstrual cup if I’m going into menopause?",
    q36: "How much money will I save by using a Menstrual Cup every month?",
    q37: "Are Menstrual Cups better for the environment than pads and tampons?",
    q38: "How do you recycle a Menstrual Cup?",
    q39: "What do I do with my current menstrual products if I switch to the cup?",
    q40: "Is the BeYou Menstrual Cup vegan-friendly and cruelty-free?",
    q41: "What is the BeYou Menstrual Cup made from?",
    q42: "What does ‘medical-grade’ silicone mean?",
    q43: "Does the BeYou Menstrual Cup contain any harmful chemicals?",
    q44: "Can I use the menstrual cup if I have given birth?",
    q45: "Can I use a menstrual cup if I have Endometriosis, PCOS, fibroids, vaginismus, adenomyosis  or another gynaecological condition",
    q46: "Can I use a menstrual cup if I get super-heavy periods - will the Menstrual Cup overflow?!",
    q47: "Can I use a menstrual cup if I have, or often get, Thrush.",
    q48: "Can I use a menstrual cup if I have a latex allergy?",
    q49: "Can I use a menstrual cup if I have a retroverted uterus?",
    q50: "Can I use the Menstrual Cup if I’ve had a prolapse?",
    q51: "Can I use a Menstrual Cup if I’m currently using a Nuvaring?",
    q52: "Can I use a menstrual cup if I have a Mirena coil or IUD fitted?",
    q53: "Can I use a Menstrual Cup if I have a high cervix? I’m not sure if the stem will be too long, stick out or irritate my labia.",
    q54: "Can I use the Menstrual Cup if I’m a virgin? Will the cup just sit against my hymen then or will it break it?",
    q55: "How do I measure my cervix, if I haven’t broken my hymen?",
    q56: "Can I use the Menstrual Cup if I have a small vaginal canal?",
    q57: "Can I use the Menstrual Cup if I have a large vaginal canal?",
    q58: "Can I use a Menstrual Cup if I pass large clots during my period?",
    q59: "Can I use a Menstrual Cup if I struggle with tampons?",
    q60: "Why are there different sizes of Menstrual Cups available?",
    q61: "How do I buy the BeYou Menstrual Cup?",
    q62: "What is included with the BeYou Menstrual Cup?",
    q63: "What is the Menstrual Cup Starter Pack?",
    q64: "Do I need to buy the Starter Pack?",
    q65: "How do the sizes of BeYou Menstrual Cups compare to other brands?",
    q66: "How many Menstrual Cups should I buy to last my full cycle?",
    q67: "Do I need to buy different sized Menstrual Cups for different days of my cycle?",
    q68: "Should I speak to a gynecologist before using a Menstrual Cup?",
    q69: "How quickly will my Menstrual Cup be delivered?",
    q70: "Is the BeYou Menstrual Cup packaging discreet?",
    q71: "Can I return a Menstrual Cup if I change my mind?",
    q72: "My first Menstrual Cup has been unused in its bag for quite a long time, can I still use it?",
    q73: "Is there anything I need to do to the Menstrual Cup before I use it?",
    q74: "Why should I practice using the Menstrual Cup before my period?",
    q75: "How to practice using a Menstrual Cup",
    q76: "Can I use my Menstrual Cup if I have just started my period or am about to?",
    q77: "What is the stem on a Menstrual Cup? Can I cut it?",
    q78: "Should I wear a pantyliner or pad the first time I use my Menstrual Cup just in case of leaks?",
    q79: "Why are there small holes in my Menstrual Cup?",
    q80: "Why are there measurements on the side of the menstrual cup?",
    q81: "Are Menstrual Cups safe to use?",
    q82: "Can you get Toxic Shock Syndrome (TSS) from using a Menstrual Cup?",
    q83: "Can you get prolapse from using a Menstrual Cup?",
    q84: "Do gynaecologists recommend using a Menstrual Cup",
    q85: "Will using a Menstrual Cup increase or help to lessen my period cramps?",
    q86: "Will using a Menstrual Cup lighten my period?",
    q87: "Can I use a Menstrual Cup for postpartum bleeding?",
    q88: "Will using a Menstrual Cup change the shape of my vagina?",
    q89: "Can I use a Menstrual Cup for discharge or cervical fluids?",
    q90: "Will using a Menstrual Cup give me thrush?",
    q91: "Can I use a Menstrual Cup after I give birth?",
    q92: "Are menstrual cups with colour safe to use? ",
    q93: "Menstrual Cups are made out of silicone, but isn’t silicone bad for my body? ",
    q94: "Do Menstrual Cups contain any phthalates or BPAs like some silicones and plastics do?",
    q95: "Can I use the menstrual cup if I’m pregnant and spotting, or have discharge?",
    q96: "There are other Menstrual Cup brands available - what makes the BeYou cup different?",
    q97: "Is the BeYou Menstrual Cup suitable for beginners?",
    q98: "What is the BeYou Menstrual Cup made from?",
    q99: "Why is the BeYou Menstrual Cup so much cheaper than other brands?",
    q100: "Is the BeYou Menstrual Cup soft or firm?",
    q101: "Is the BeYou Menstrual Cup tested on animals?",
    q102: "Where is the BeYou Menstrual Cup manufactured?",
    q103: "What is the difference between this and a Mooncup?",
    q104: "If a menstrual cup is smooth, is it a good thing?",
    q105: "Why am I experiencing UTI symptoms since using the Menstrual Cup?",
    q106: "How do I avoid an infection when using the Menstrual Cup?",
    q107: "How do I prevent bacteria from getting onto my Menstrual Cup?",
    q108: "I wash my Menstrual Cup with a bar of soap and I think this has caused an irritation to my vagina and its pH levels.",
    q109: "I’m experiencing a very itchy vulva/vagina since using a Menstrual Cup - am I allergic to silicone?",
    q110: "How can I use my Menstrual Cup to tell if my flow is too heavy or too light to detect any underlying conditions?",
    q111: "How can I use my Menstrual Cup to track my health?",
    q112: "Removing my Menstrual Cup is quite painful due to vaginal dryness - what can I do?",
    q113: "How do you insert a cup with different positions?",
    q114: "How do you fold a Menstrual Cup?",
    q115: "Where should my Menstrual Cup be positioned inside of me?",
    q116: "Can I use lube to help insert my Menstrual Cup?",
    q117: "Is it normal for my Menstrual Cup to not open up right away?",
    q118: "How do I get my Menstrual Cup to fully open out inside of me?",
    q119: "What exactly is ‘the seal’?",
    q120: "How do I get my Menstrual Cup to form a seal?",
    q121: "It hurts when I insert my Menstrual Cup - do I need another size?",
    q122: "What should a Menstrual Cup feel like once it's inside me and how do I know if my cup is inserted correctly?",
    q123: "Should I remove and clean my Menstrual Cup every time I go to the toilet?",
    q124: "I’ve heard you aren’t supposed to use a tampon on light flow days. Can you use a menstrual cup when you have a lighter period?",
    q125: "Why do I find I can’t pee as hard when I have my Menstrual Cup in?",
    q126: "Can I use the Menstrual Cup during the lighter/heavier days of my period?",
    q127: "Will people be able to tell I’m using a Menstrual Cup?",
    q128: "How does a Menstrual Cup stay in place without falling out?",
    q129: "How does the position of my cervix change throughout my cycle, and how does this affect the placement of my cup?",
    q130: "How long can it take to get used to using a Menstrual Cup?",
    q131: "Why is my Menstrual Cup painful or uncomfortable?",
    q132: "Why is my cup leaking if I haven’t had it in longer than I should?",
    q133: "What might be causing my Menstrual Cup to leak at night?",
    q134: "Is it dangerous that the cup reaches up to my cervix?",
    q135: "The stem of my Menstrual Cup rubs against me - is this normal?",
    q136: "Is it normal for the stem of my cup to be exposed?",
    q137: "Why does my Menstrual Cup keep sliding down/rising up?",
    q138: "Can air bubbles in my Menstrual Cup give off a bad/sour smell when removing the cup?",
    q139: "How does the position of my cervix change throughout my cycle, and how does this affect the placement of my Menstrual Cup?",
    q140: "Can I use pads with my Menstrual Cup for added protection?",
    q141: "How do I clean and empty my Menstrual Cup in a public toilet?",
    q142: "How do I clean and empty my Menstrual Cup at work?",
    q143: "How should I clean my Menstrual Cup at school?",
    q144: "How should I clean my Menstrual Cup in my shared University Halls bathrooms?",
    q145: "Can I wear a Menstrual Cup during P.E?",
    q146: "Do you offer student discount on Menstrual Cups?",
    q147: "Can I do sports with a Menstrual Cup in?",
    q148: "Is a Menstrual Cup uncomfortable to wear during sports?",
    q149: "Wouldn’t my Menstrual Cup fall out if I’m running?",
    q150: "Can I use a Menstrual Cup while doing yoga, particularly the upside down or inverted postures?",
    q151: "Can I use my Menstrual Cup in a sauna or jacuzzi?",
    q152: "Can I use a Menstrual Cup when swimming? ",
    q153: "How do I empty and clean my Menstrual Cup at the gym?",
    q154: "Will the change in air pressure on a flight affect my menstrual cup?",
    q155: "How do I clean my Menstrual Cup if I am travelling with no access to clean water?",
    q156: "Would a body-scanner at an airport see my Menstrual Cup when travelling?",
    q157: "Can I use a Menstrual Cup when scuba diving?",
    q158: "I removed the Menstrual Cup without breaking the suction and now I’m struggling with constipation and it hurts. Is this normal?",
    q159: "How much fluid fits into my BeYou Menstrual Cup and how often does that mean I should be removing and emptying it?",
    q160: "How do I break the seal of the cup?",
    q161: "How do I remove my Menstrual Cup? Where do I start?",
    q162: "I removed my Menstrual Cup without breaking the suction and now I’m feeling constipated and it hurts. Is this normal?",
    q163: "How do I empty my Menstrual Cup?",
    q164: "Where do I empty my Menstrual Cup?",
    q165: "My cup has risen and I can’t reach it to remove it - what should I do?",
    q166: "How do I break the seal of my menstrual cup?",
    q167: "My cup is stuck, it’s been in for longer than 12 hours and I’m starting to panic - what should I do?",
    q168: "I heard I can have sex with the Menstrual Cup in - is this true? Will they feel it?",
    q169: "How many ml fit into my Menstrual Cup and how often does that mean I should be emptying it?",
    q170: "Would my Menstrual Cup be visible on an X-ray?",
    q171: "Can I share my Menstrual Cup with someone else?",
    q172: "I heard I can have sex with the Menstrual Cup in? Will they feel it?",
    q173: "Can I masturbate whilst using the Menstrual Cup?",
    q174: "Can I keep my Menstrual Cup in whilst using a vibrator or sex toy?",
    q175: "Can I receive oral sex while wearing a Menstrual Cup?",
    q176: "Can my Menstrual Cup be used as a contraceptive device?",
    q177: "Can I use my Menstrual Cup to protect me from STDs?",
    q178: "Can I use a Menstrual Cup alongside my contraceptive?",
    q179: "How should I clean my Menstrual Cup in public?",
    q180: "How often should I clean my Menstrual Cup?",
    q181: "How often should I fully sterilise my Menstrual Cup?",
    q182: "Can I use a microwave to sterilise my Menstrual Cup?",
    q183: "Can I put my Menstrual Cup in the dishwasher or washing machine?",
    q184: "What does the white residue on the cup mean after sterilising?",
    q185: "Why does my Menstrual cup smell?",
    q186: "The ridge/groove of my Menstrual Cup needs a more thorough cleaning, what should I do?",
    q187: "How should I store my Menstrual Cup?",
    q188: "How often should I replace my Menstrual Cup?",
    q189: "My Menstrual Cup fell in the toilet! What should I do?",
    q190: "How should I sterilise my cup when travelling?",
    q191: "How can I stop my Menstrual Cup discolouring or staining?",
    q192: "Can I overheat my menstrual cup?",
    q193: "Can urine or any other bodily fluids damage my Menstrual Cup?",
    q194: "Is there anything that can damage my Menstrual Cup?",
    q195: "How should I clean my Menstrual Cup storage pouch?"
};
